import { Buffer } from "buffer";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { generateCodeChallenge, generateCodeVerifier } from "../pkce/pkce";
import { useAuth } from "./AuthContext";
import { appUrl, authServer } from "./app_props";
import { clearAuth, takePostLoginTarget } from "./authStorage";

const Redirect = () => {
  const { login, user } = useAuth();
  const verifier = generateCodeVerifier();
  sessionStorage.setItem("codeVerifier", verifier);
  const codeChallenge = generateCodeChallenge();
  sessionStorage.setItem("codeChallenge", codeChallenge);

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const clientId = "compliance-react-client";
  const clientSecret = "compliance-service";
  useEffect(() => {
    if (searchParams?.get("code")) {
      const code = searchParams?.get("code");

      // Establishing a fresh session - drop any identity left over from a
      // previously signed-in user before we exchange the new code.
      clearAuth();

      const headers = new Headers();
      headers.append("Content-type", "application/json");
      headers.append(
        "Authorization",
        `Basic ${Buffer.from(`${clientId}:${clientSecret}`).toString("base64")}`
      );

      const verifier = sessionStorage.getItem("codeVerifier");

      const initialUrl = `${authServer}/oauth2/token?client_id=${clientId}&redirect_uri=${appUrl}/authorized&grant_type=authorization_code`;
      const url = `${initialUrl}&code=${code}&code_verifier=${verifier}`;

      const origin = window.location.origin;

      headers.append("allowed_cors_origins", origin);
      fetch(url, {
        method: "POST",
        mode: "cors",
        headers,
      })
        .then(async (response) => {
          const token = await response.json();
          if (token?.id_token) {
            sessionStorage.setItem("id_token", token.id_token);
            login(token.id_token);
            navigate(takePostLoginTarget() || "/dashboard");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [searchParams]);
  useEffect(() => {
    if (!searchParams?.get("code")) {
      const codeChallenge = sessionStorage.getItem("codeChallenge");
      const link = `${authServer}/oauth2/authorize?response_type=code&client_id=${clientId}&scope=openid&redirect_uri=${appUrl}/authorized&code_challenge=${codeChallenge}&code_challenge_method=S256`;

      window.location.href = link;
      // login(sessionStorage.getItem('id_token'));
      // navigate('/home');
    }
  }, [user]);
  return <p>Redirecting ...</p>;
};

export default Redirect;
